<template>
  <div class="table-container">
    <!-- 筛选框 -->
    <AreaTableFilter
      ref="tableFilter"
      :multiButton="multiButton"
      @handleMultiConcern="handleMultiConcern"
      :downloadUrl="downloadUrl"
    >
    </AreaTableFilter>
    <!-- 地区表格 -->
    <div class="area-table" :style="{ height: `calc(${filterHeight})` }">
      <!-- height高度=100% - paginationHeight32px - padding20px -->
      <el-table
        height="calc(100% - 52px)"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        style="width: 100%"
        @select="handleTableSelect"
        @selection-change="handleTableSelect"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column label="地区">
          <template slot-scope="scope">
            <div class="from-container">
              <span>{{ scope.row.from }}</span>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.concernStatus ? '取消关注' : '点击关注'"
                placement="right"
              >
                <el-rate
                  @change="
                    handleConcerned(scope.row.concernStatus, scope.$index)
                  "
                  :max="1"
                  :value="scope.row.concernStatus"
                ></el-rate>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="com" label="快递公司"> </el-table-column>
        <el-table-column label="揽件情况">
          <template slot-scope="scope">
            <div
              :class="scope.row.isPickUp == 'N' ? 'error-dot' : 'normal-dot'"
            >
              {{ scope.row.isPickUp == "N" ? "异常" : "正常" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="派件情况">
          <template slot-scope="scope">
            <div
              :class="scope.row.isDeliver == 'N' ? 'error-dot' : 'normal-dot'"
            >
              {{ scope.row.isDeliver == "N" ? "异常" : "正常" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signRate" label="妥投率"> </el-table-column>
        <el-table-column prop="returnRate" label="退签率"> </el-table-column>
      </el-table>
      <Pagination
        @current-change="pageChange"
        @size-change="sizeChange"
        :total="totalCount"
        :page="page"
      >
      </Pagination>
    </div>
  </div>
</template>

<script>
import AreaTableFilter from "./AreaTableFilter.vue";
import Pagination from "@/components/Pagination/index.vue";
import { fetchCancelConcern, fetchAddConcern } from "@/utils/api/concerned";
export default {
  props: ["tableData", "totalCount", "downloadUrl"],
  components: {
    AreaTableFilter,
    Pagination,
  },
  data() {
    return {
      filterHeight: "60px",
      checkRows: [],
      multiButton: true,
    };
  },
  mounted() {
    this.filterHeight = `100% - ${
      this.$refs.tableFilter ? this.$refs.tableFilter.$el.offsetHeight : 0
    }px`;
    this.$store.dispatch("com/getComDict");
  },
  computed: {
    loading() {
      return this.$store.getters.areaTableLoading;
    },
    page() {
      return this.$store.getters.areaTableFilter.page;
    },
  },
  watch: {
    tableData() {
      this.multiButton = true;
      this.checkRows = [];
    },
  },
  methods: {
    handleTableSelect(selection) {
      this.multiButton = selection.length == 0;
      this.checkRows = selection;
    },
    handleMultiConcern() {
      const notConcernList = this.checkRows.filter(
        (item) => !item.concernStatus
      );
      this.fetchAddConcern(notConcernList);
    },
    handleConcerned(concerned, index) {
      const currentData = this.tableData[index];
      if (concerned) {
        this.fetchCancelConcern([currentData]);
      } else {
        this.fetchAddConcern([currentData]);
      }
    },
    fetchAddConcern(list) {
      fetchAddConcern([...list])
        .then(() => {
          this.$message({
            message: "关注成功",
            type: "success",
            duration: 1500,
          });
          this.$store.dispatch("com/resetAreaTableFilter");
        })
        .catch(() => {
          this.$message({
            message: "关注失败",
            type: "error",
            duration: 1500,
          });
        });
    },
    fetchCancelConcern(list) {
      fetchCancelConcern([...list])
        .then(() => {
          this.$message({
            message: "取消关注成功",
            type: "success",
            duration: 1500,
          });
          this.$store.dispatch("com/resetAreaTableFilter");
        })
        .catch(() => {
          this.$message({
            message: "取消关注失败,请重试",
            type: "error",
            duration: 1500,
          });
        });
    },
    pageChange(page) {
      this.$store.dispatch("com/setAreaTableFilter", {
        page,
      });
    },
    sizeChange(size) {
      this.$store.dispatch("com/setAreaTableFilter", {
        size,
      });
    },
  },
};
</script>

<style lang="less">
.table-container {
  height: 100%;

  .area-table {
    .from-container {
      display: flex;
      align-items: center;

      > span {
        margin-right: 5px;
      }
    }

    .el-pagination {
      margin-top: 10px;
      float: right;
    }
  }

  .normal-dot,
  .error-dot {
    position: relative;
    padding-left: 10px;

    &::before {
      content: "";
      width: 5px;
      height: 5px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
  }

  .normal-dot {
    &::before {
      background: #00a854;
    }
  }

  .error-dot {
    &::before {
      background: #f04134;
    }
  }
}
</style>
